import type { Action, Dispatch, MiddlewareAPI } from 'redux';

export interface EventsMap<T> {
  [key: string]: (state: T, nextState: T, action: Action, dispatch: Dispatch) => void;
}

export const createMiddlewareFromEventsMap =
  <T>(eventsMap: EventsMap<T>) =>
  (api: MiddlewareAPI) =>
  (next: Dispatch) =>
  (action: Action) => {
    const { dispatch, getState } = api;
    const prevState = getState();
    const returnVal = next(action);
    const nextState = getState();
    const event = eventsMap[action.type];

    if (event) {
      event(prevState, nextState, action, dispatch);
    }

    return returnVal;
  };
